import React, { ReactNode } from 'react';
import './App.css';
import { routes } from "./routes";
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import LoginPage from './pages/auth/loginPage';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';
import ForgottenPasswordPage from './pages/auth/ForgottenPasswordPage';
import ResetPasswordPage from './pages/auth/PasswordResetPage';
import AltLayout from './components/layout/AltLayout';
import UsersPage from './pages/users/UsersPage';

const loginpage = "/login";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const authData = useSelector((state: RootState) => state.auth);
  if (!authData.isAuthenticated && authData.access) {
    return <>{children}</> // Show Signin Dialogue Box
  }
  return authData.isAuthenticated ? <>{children}</> : <Navigate to={loginpage} replace />;
};

function App() {
  const authData = useSelector((state: RootState) => state.auth);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          <Route index element={<UsersPage />} />
          {routes}
        </Route>
        <Route path="/login" element={<AltLayout />}>
          <Route index element={<LoginPage />} />
        </Route>
        <Route path="/forgot-password" element={<AltLayout />}>
          <Route index element={<ForgottenPasswordPage />} />
        </Route>
        <Route path="/reset/:uidb64/:token" element={<AltLayout />}>
          <Route index element={<ResetPasswordPage />} />
        </Route>
        <Route path="*" element={<Navigate to={authData.isAuthenticated ? "/" : loginpage} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
